<template>
	<v-card class="personal-profile__section">
		<div class="d-flex justify-space-between">
			<span class="personal-profile__section__title"> Note </span>

			<button @click="$emit('edit')" class="personal-profile__section__note-button">
				{{ !note ? 'Add Note' : 'Edit Note' }}
			</button>
		</div>

		<span class="personal-profile__section__bio" v-html="note" />
	</v-card>
</template>

<script>
export default {
	props: {
		note: String,
	},
}
</script>
